<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          supervisor_account
        </v-icon>
        <h2 class="display-2">
          Deine Mannschaft
        </h2>
      </v-col>
    </v-row>

    <v-row class="my-6 d-none d-sm-flex">
      <v-col class="text-center">
        <v-btn-toggle
          v-model="toggleActive"
          rounded
          background-color="primary darken-1"
          dark
        >
          <v-btn to="/mannschaft">
            Übersicht
          </v-btn>
          <v-btn>
            Aufstellung
          </v-btn>
          <v-btn to="/training">
            Training / Trainingslager
          </v-btn>
          <v-btn to="/vertrag">
            Verträge
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col cols="12" class="display-2">
        Aufstellung
      </v-col>
      <v-col cols="12" class="body-1">
        <b>nächtes Spiel:</b> {{ $store.state.office.nextGame.text }}<br>
        {{ this.aufstellungsList.length }} von {{ this.maxPlayers }} Spieler in deiner Aufstellung
      </v-col>
    </v-row>

    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      justify="center"
      class="my-4 mb-12"
    >
      <v-col cols="10" class="caption grey lighten-2">
        Die Funktionsweise der Aufstellung hat sich etwas geändert. Wähle zuerst Deine Spieler aus, die im nächsten Spieltag antreten sollen. Danach scroll etwas runter und sortiere die Spieler auf die richtige Position. Danach speichere Deine Aufstellung.
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col cols="12" class="text-center">
        <h2 class="display-2">
          Deine Spieler
        </h2>
        <span class="caption">(Wähle Deine Spieler die am nächsten Spieltag spielen sollen.)</span>
      </v-col>
    </v-row>

    <v-row
      v-for="(item) in teamList"
      :key="item.name"
      justify="center"
      class="my-4"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              class="text-center flex-grow-0"
              cols="12"
              sm="2"
            >
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-avatar
                    :color="item.position | positionColorString('color')"
                    size="62"
                    v-on="on"
                    class="white--text"
                  >
                    {{ item.position }}
                  </v-avatar>
                </template>
                <span>{{ item.position | positionColorString('string') }}</span>
              </v-tooltip>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              class="text-center"
            >
              <v-row>
                <v-col :class="item.position | positionColorString('color')" class="title white--text py-2">
                  {{ item.name }}
                </v-col>
              </v-row>
              <v-row
                justify="center"
                align="center"
              >
                <v-col cols="3" class="body-2 font-weight-bold">
                  Heim-Index:
                </v-col>
                <v-col cols="3" class="body-1 font-weight-bold blue--text text--darken-3">
                  {{ item.heimIndex }} Holz
                </v-col>
                <v-col cols="3" class="body-2 font-weight-bold">
                  Ausw.-Index:
                </v-col>
                <v-col cols="3" class="body-1 font-weight-bold blue--text text--darken-3">
                  {{ item.auswIndex }} Holz
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-center">
                  <h6>Kraft</h6>
                  <v-progress-circular
                    :value="item.kraft"
                    :color="item.kraft | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.kraft }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Motivation</h6>
                  <v-progress-circular
                    :value="item.motivation"
                    :color="item.motivation | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.motivation }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Technik</h6>
                  <v-progress-circular
                    :value="item.technik"
                    :color="item.technik | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.technik }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Kondition</h6>
                  <v-progress-circular
                    :value="item.kondition"
                    :color="item.kondition | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.kondition }}</small>
                  </v-progress-circular>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              class="text-center"
            >
              <v-divider class="d-flex d-sm-none mb-2" />

              <p v-if="!isInAufstellung(item)" class="body-2 font-weight-bold">
                Zur Aufstellung hinzufügen
              </p>
              <p v-else class="body-2 font-weight-bold">
                Von Aufstellungsliste entfernen
              </p>

              <div class="d-flex ml-auto mr-auto text-center">
                <v-switch
                  v-model="aufstellungsList"
                  :value="item"
                  :disabled="aufstellungsList.length >= maxPlayers && !isInAufstellung(item)"
                  :label="isInAufstellung(item)? 'aufgestellt': 'auswählen'"
                  class="mx-auto"
                />
              </div>
              <span
                v-if="aufstellungsList.length >= maxPlayers && !isInAufstellung(item)"
                class="overline red--text"
              >
                Maximale Spieleranzahl erreicht.
              </span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
      class="mt-8"
    >
      <v-col cols="12" class="text-center">
        <h2 class="display-2">
          Deine Aufstellung
        </h2>
        <span class="caption">(Sortiere Deine Spieler auf die richtige Position und speichere die Aufstellung.)</span>
      </v-col>
    </v-row>

    <v-row
      v-for="(item, index) in aufstellungsList"
      :key="'Aufstellung_'+item.name"
      justify="center"
      class="my-4"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              class="text-center flex-grow-0"
              cols="12"
              sm="2"
            >
              Position {{ index+1 }}<br>
              <span v-if="index==0 || index==1">Start</span>
              <span v-if="index==2 || index==3">Mitte</span>
              <span v-if="index==4 || index==5">Schluss</span>
            </v-col>
            <v-col
              class="text-center flex-grow-0"
              cols="12"
              sm="2"
            >
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-avatar
                    :color="item.position | positionColorString('color')"
                    size="62"
                    v-on="on"
                    class="white--text"
                  >
                    {{ item.position }}
                  </v-avatar>
                </template>
                <span>{{ item.position | positionColorString('string') }}</span>
              </v-tooltip>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              class="text-center"
            >
              <v-row>
                <v-col :class="item.position | positionColorString('color')" class="title white--text py-2">
                  {{ item.name }}
                </v-col>
              </v-row>
              <v-row
                justify="center"
                align="center"
              >
                <v-col cols="3" class="body-2 font-weight-bold">
                  Heim-Index:
                </v-col>
                <v-col cols="3" class="body-1 font-weight-bold blue--text text--darken-3">
                  {{ item.heimIndex }} Holz
                </v-col>
                <v-col cols="3" class="body-2 font-weight-bold">
                  Ausw.-Index:
                </v-col>
                <v-col cols="3" class="body-1 font-weight-bold blue--text text--darken-3">
                  {{ item.auswIndex }} Holz
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-center">
                  <h6>Kraft</h6>
                  <v-progress-circular
                    :value="item.kraft"
                    :color="item.kraft | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.kraft }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Motivation</h6>
                  <v-progress-circular
                    :value="item.motivation"
                    :color="item.motivation | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.motivation }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Technik</h6>
                  <v-progress-circular
                    :value="item.technik"
                    :color="item.technik | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.technik }}</small>
                  </v-progress-circular>
                </v-col>
                <v-col class="text-center">
                  <h6>Kondition</h6>
                  <v-progress-circular
                    :value="item.kondition"
                    :color="item.kondition | getStatusColor"
                    size="32"
                  >
                    <small>{{ item.kondition }}</small>
                  </v-progress-circular>
                </v-col>
              </v-row>
            </v-col>

            <v-col class="text-center">
              <v-divider class="d-flex d-sm-none mb-2" />
              <p class="caption">
                Position
                <span v-show="index > 0">rauf</span>
                <span v-show="index > 0 && index < 5 && index + 1 < aufstellungsList.length"> / </span>
                <span v-show="index < 5 && aufstellungsList.length > 1 && index + 1 < aufstellungsList.length">runter</span>
              </p>
              <v-row
                justify="center"
              >
                <v-col v-if="index > 0">
                  <v-btn
                    text icon
                    @click="moveIndex(index, -1, item)"
                  >
                    <v-icon>mdi-arrow-up-bold-circle-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col v-if="index < 5 && aufstellungsList.length > 1 && index + 1 < aufstellungsList.length">
                  <v-btn
                    text icon
                    @click="moveIndex(index, +1, item)"
                  >
                    <v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card
          outlined
          class="text-center py-6"
        >
          <my-alert
            v-if="$store.state.error"
            :error="$store.state.error"
            :title="$store.state.errorTitle"
            type="error"
          />

          <v-btn
            :loading="$store.state.loading"
            :disabled="$store.state.loading"
            color="primary"
            class="mx-auto"
            @click.native="saveAufstellung"
          >
            Aufstellung speichern
          </v-btn>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="10"
        sm="8"
      >
        <v-card
          hover
        >
          <v-card-title
            class="title orange-background"
          >
            <h3 class="mx-auto white--text">
              Mannschaftswerte durch Deine Aufstellung
            </h3>
          </v-card-title>
          <v-divider />
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                Heimindex
              </h4>
              <v-progress-circular
                :value="percentHeimindex"
                :color="percentHeimindex | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ heimIndex }}</b>
              </v-progress-circular>
              <h5 class="subtitle-2">
                ∅ {{ avgHeimindex }} /  max: {{ heimIndex_max }}
              </h5>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                Auswindex
              </h4>
              <v-progress-circular
                :value="percentAuswindex"
                :color="percentAuswindex | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ auswIndex }}</b>
              </v-progress-circular>
              <h5 class="subtitle-2">
                ∅ {{ avgAuswindex }} /  max: {{ auswIndex_max }}
              </h5>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                ∅<br>Kraft<br>
                <v-icon
                  :color="avgKraft | getStatusColor"
                >
                  mdi-dumbbell
                </v-icon>
              </h4>
              <v-progress-circular
                :value="avgKraft"
                :color="avgKraft | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ avgKraft }}</b>
              </v-progress-circular>
            </v-col>

            <v-col
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                ∅<br>Motivation<br>
                <v-icon
                  :color="$store.state.office.motivation | getStatusColor"
                >
                  mdi-brain
                </v-icon>
              </h4>
              <v-progress-circular
                :value="avgMotivation"
                :color="avgMotivation | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ avgMotivation }}</b>
              </v-progress-circular>
            </v-col>

            <v-col
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                ∅<br>Technik<br>
                <v-icon
                  :color="$store.state.office.technik | getStatusColor"
                >
                  mdi-webcam
                </v-icon>
              </h4>
              <v-progress-circular
                :value="avgTechnik"
                :color="avgTechnik | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ avgTechnik }}</b>
              </v-progress-circular>
            </v-col>

            <v-col
              class="text-center"
            >
              <h4 class="subtitle-2 mb-2">
                ∅<br>Kondition<br>
                <v-icon
                  :color="$store.state.office.kondition | getStatusColor"
                >
                  mdi-heart-pulse
                </v-icon>
              </h4>
              <v-progress-circular
                :value="avgKondition"
                :color="avgKondition | getStatusColor"
                size="48"
                class="mb-2"
              >
                <b>{{ avgKondition }}</b>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_SET_SNACKBAR } from '../store/mutation-types'
const R = require('ramda')

export default {
  name: 'Aufstellung',
  components: {
  },
  metaInfo: {
    title: 'Mannschaft - Aufstellung'
  },
  data: function () {
    return {
      toggleActive: 1,
      teamList: [],
      aufstellungsList: [],
      maxPlayers: 6,
      heimIndex: 0,
      heimIndex_max: 0,
      auswIndex: 0,
      auswIndex_max: 0,
      avgKraft: 0,
      avgMotivation: 0,
      avgTechnik: 0,
      avgKondition: 0,
      avgHeimindex: 0,
      avgAuswindex: 0
      // percentHeimindex: 0
    }
  },
  // filters: {
  //   shortName: function (value) {
  //     let name = value
  //     if (!name) return name
  //     let nameArray = R.split(' ', name.toString())

  //     return R.slice(0, 1, nameArray[0]) + '. ' + nameArray[1]
  //   }
  // },
  mounted: async function () {
    // load changelogs in store from cache or from server if cache is not valid
    if (await this.$store.dispatch('teamStore/loadAufstellung')) {
      this.aufstellungsList = this.$store.state.teamStore.aufstellung
      const orderedTeamlist = this.$options.filters.sortByPosition(this.$store.state.teamStore.players)
      // make a diff to aufstellung und ordered lsit
      this.teamList = orderedTeamlist // R.difference(orderedTeamlist, this.aufstellungsList)
      this.calcAll()
    }
  },
  computed: {
    percentHeimindex: function () {
      return Math.round((this.heimIndex / this.heimIndex_max) * 100)
    },
    percentAuswindex: function () {
      return Math.round((this.auswIndex / this.auswIndex_max) * 100)
    }
  },
  watch: {
    aufstellungsList: function (oldList, newList) {
      this.calcAll()
    }
  },
  methods: {
    moveIndex: function (oldIndex, step, player) {
      const newList = R.move(oldIndex, oldIndex + step, this.aufstellungsList)
      this.aufstellungsList = newList
      this.calcAll()
    },
    isInAufstellung: function (player) {
      return R.not(R.isNil(R.find(R.propEq('id', player.id))(this.aufstellungsList)))
    },
    saveAufstellung: function () {
      if (this.aufstellungsList.length < this.maxPlayers) {
        this.$store.commit(ROOT_SET_SNACKBAR, `Achtung, Du hast nur ${this.aufstellungsList.length} von möglichen ${this.maxPlayers} Spieler aufgestellt.`)
      }
      // send only the player ids
      const getOnlyId = R.pick(['id'])
      const aufstellung = R.map(getOnlyId, this.aufstellungsList)
      // save aufstellung with store component
      this.$store.dispatch('teamStore/saveAufstellung', aufstellung)
    },
    calcIndex: function () {
      this.auswIndex = 0
      this.heimIndex = 0
      this.auswIndex_max = 0
      this.heimIndex_max = 0
      // no calculation on empty list
      if (R.isEmpty(this.aufstellungsList)) {
        return 0
      }
      // calc heimIndex
      const setHeimIndex = (value, key) => this.getIndexValueFromPosition(value, key, 'heimIndex', 'heimIndex', false)
      R.forEachObjIndexed(setHeimIndex, this.aufstellungsList)
      // calc auswIndex
      const setAuswIndex = (value, key) => this.getIndexValueFromPosition(value, key, 'auswIndex', 'auswIndex', false)
      R.forEachObjIndexed(setAuswIndex, this.aufstellungsList)
      // calc heimIndex max
      const setHeimIndexMax = (value, key) => this.getIndexValueFromPosition(value, key, 'heimIndex_max', 'heimIndex_max', true)
      R.forEachObjIndexed(setHeimIndexMax, this.aufstellungsList)
      // calc auswIndex max
      const setAuswIndexMax = (value, key) => this.getIndexValueFromPosition(value, key, 'auswIndex_max', 'auswIndex_max', true)
      R.forEachObjIndexed(setAuswIndexMax, this.aufstellungsList)
    },
    calcVital: function () {
      this.avgKraft = 0
      this.avgMotivation = 0
      this.avgTechnik = 0
      this.avgKondition = 0
      this.avgHeimindex = 0
      this.avgAuswindex = 0
      // no calculation on empty list
      if (R.isEmpty(this.aufstellungsList)) {
        return 0
      }
      /*
      Berechne die Durchschnitte der Mannschaftswerte
      https://codereview.stackexchange.com/questions/141530/calculate-average-of-array-of-objects-per-key-value-using-reduce
      */
      var playerData = this.aufstellungsList
      var avg = Array.from(playerData.reduce(
        (acc, obj) => Object.keys(obj).reduce(
          (acc, key) => typeof obj[key] === 'number'
            ? acc.set(key, (acc.get(key) || []).concat(obj[key]))
            : acc,
          acc),
        new Map())).reduce(
        (acc, [name, values]) =>
          Object.assign(acc, { [name]: Math.round(values.reduce((a, b) => a + b) / values.length) }),
        {}
      )
      this.$store.state.office.kraft = this.avgKraft = avg.kraft
      this.$store.state.office.motivation = this.avgMotivation = avg.motivation
      this.$store.state.office.technik = this.avgTechnik = avg.technik
      this.$store.state.office.kondition = this.avgKondition = avg.kondition
      this.$store.state.office.heimIndex = this.avgHeimindex = avg.heimIndex
      this.$store.state.office.auswIndex = this.avgAuswindex = avg.auswIndex
    },
    getIndexValueFromPosition: function (value, key, welcherIndex, dataValue, max) {
      let index = value[welcherIndex]
      const keyValue = (key * 1)
      const position = value.position
      if (!max) {
        // get new index , check if the right position or make punishment
        index = this.getIndex(position, index, keyValue)
      }
      this[dataValue] += index
    },
    getIndex: function (position, index, keyValue) {
      let newIndex = index
      switch (position) {
        case 'A':
          newIndex -= keyValue < 2 ? 0 // startspieler an der richtigen stelle: - 0
            : keyValue < 4 ? 10 // startspieler in der mitte: -10
              : 20 // startspieler ganz hinten: -20
          break
        case 'M':
          newIndex -= keyValue < 2 ? 10 // mittelspieler an startposition
            : keyValue < 4 ? 0 // mittelspieler richtig
              : 10 // mittelspieler an schluss position
          break
        case 'S':
          newIndex -= keyValue < 2 ? 20 // mittelspieler an startposition
            : keyValue < 4 ? 10 // mittelspieler richtig
              : 0 // mittelspieler an schluss position
          break
        default:
          newIndex -= 5
          break
      }
      return newIndex
    },
    // checkMove: function (e) {
    //   if (this.aufstellungsList.length > (this.maxPlayers - 1)) {
    //     this.$store.commit(ROOT_SET_SNACKBAR, 'Für die Aufstellung, hast Du die maximale Anzahl an Spieler erreicht.')
    //     return false
    //   }
    // },
    calcAll: function () {
      this.calcIndex()
      this.calcVital()
    }
    // ,
    // add: function (e) {
    //   // calculate mannschaftsindex
    //   this.calcAll()
    // },
    // remove: function (e) {
    //   // order team list
    //   this.teamList = this.$options.filters.sortByPosition(this.teamList)
    //   // calculate mannschaftsindex
    //   this.calcAll()
    // }
  }
}
</script>

<style scoped>
.orange-background {
  background-color: #FF7F50 !important;
  background-image: -webkit-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: -moz-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: -o-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
}

</style>
